type IconType = 'book' | 'heart' | 'star' | 'check';

type Props = {
  icon?: IconType;
  heading: string;
  description?: string;
};

function IconSvg({ icon }: { icon: IconType }) {
  const color = 'var(--m-blue)';
  switch (icon) {
    case 'book':
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
      );
    case 'heart':
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      );
    case 'star':
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      );
    case 'check':
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      );
  }
}

export function CalloutBlock({ icon = 'book', heading, description }: Props) {
  return (
    <div style="max-width: 860px; margin: 0 auto; padding: 0 20px;">
      <div style="display: flex; align-items: center; gap: 12px; margin: 36px 0 10px;">
        <div style="width: 32px; height: 32px; flex-shrink: 0;">
          <IconSvg icon={icon} />
        </div>
        <div>
          <p style="font-size: 22px; font-weight: 700; color: #333; margin: 0;">{heading}</p>
          {description && (
            <p style="font-size: 16px; line-height: 1.7; color: #616161; margin: 8px 0 0;">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
